import React, { useEffect, useState } from "react"
import { Modal, Form, Row, Col ,Button} from "antd"
import { ApiCalls } from "../../../shared/ApiCalls"
import { MyInput } from "../../Forms"

const AddEditPortalModal = ({open, onClose,editbox, getAllApplications }) => {
    
    const [form] = Form.useForm()
    const [loading, setLoading ] = useState(false)  
  
    useEffect(() => {
        if (open && editbox) {
            form.setFieldsValue({...editbox})
        } else {
            form.resetFields()
        }
    }, [open, editbox])

    const onFinish = async () => {
        try {
            let formData= await form.validateFields()
            setLoading(true)
            formData= {
                ...formData,
                addedFor: 1
            }
            const result = await ApiCalls.boxManagementGo.addEditPortal({...formData, id: editbox?.id});
            setLoading(false)
            if(result){
                closeDrawer()
                getAllApplications()
            }
        } catch (error) {
            console.error("Form validation error:", error);
        }
    }
    const closeDrawer= ()=>{
        form.resetFields()
        onClose()
    }

  return (
    <div>
        <Modal
            title={editbox?'Edit portal':'Add portal'}
            onClose={closeDrawer}
            onCancel={onClose}
            open={open}
            width={600}
            centered
            footer={
                [
                    <Button 
                        size="large"
                        onClick={closeDrawer}
                    >
                        Cancel
                    </Button>,
                    <Button  
                        size="large"
                        type="primary"
                        htmlType="submit"
                        loading={loading}
                        onClick={()=> form.submit()}
                    >
                        {
                            editbox? 'Update portal' : 'Save portal'
                        }
                    </Button>
                ]
            }
        >
            <Form
                form={form}
                layout="vertical"
                onFinish={onFinish}
            >
                <Row gutter={16}>
                    <Col span={24}>
                        <MyInput
                            label='Name'
                            name='name'
                            placeholder='e.g My M3u'
                            required
                            message='please enter name'
                            size='large'
                        />
                    </Col>
                    <Col span={24}>
                        <MyInput
                            label='Url'
                            name='url'
                            placeholder='e.g free.api.com'
                            required
                            message='please enter url'
                            size='large'
                        />
                    </Col>
                </Row>
            </Form>
        </Modal>
    </div>
  )
}

export {AddEditPortalModal}